import { render, staticRenderFns } from "./FirebaseProjects.vue?vue&type=template&id=08101be7&"
import script from "./FirebaseProjects.vue?vue&type=script&lang=js&"
export * from "./FirebaseProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports